import http from "@/http-common";

/**
 * Service quản lý khoản thu chính (Managing Total Revenue)
 * Base URL: /receipt/v1/tuition/managing-total-revenues
 * Lưu ý: idSchool KHÔNG cần truyền – BE tự xác định qua JWT token.
 */
class ManagingTotalRevenueService {
  /**
   * Tìm kiếm danh sách khoản thu chính có phân trang
   * @param {Object} params - { keyword, category, hasFormula, taxDeclaration, issuingElectronicInvoices, page, size }
   */
  search(params) {
    return http.get("receipt/v1/tuition/managing-total-revenues", { params });
  }

  /**
   * Lấy chi tiết một khoản thu chính theo ID
   * @param {string} id - UUID
   */
  findById(id) {
    return http.get(`receipt/v1/tuition/managing-total-revenues/${id}`);
  }

  /**
   * Tạo mới khoản thu chính
   * @param {Object} data - TotalRevenueCreateRequest (không cần idSchool)
   */
  create(data) {
    return http.post("receipt/v1/tuition/managing-total-revenues", data);
  }

  /**
   * Cập nhật khoản thu chính
   * @param {string} id - UUID
   * @param {Object} data - TotalRevenueUpdateRequest (không cần idSchool)
   * ⚠️ Chiến lược Replace-all: BE xóa toàn bộ formulaMappings / configList cũ rồi insert lại.
   * → FE phải gửi đầy đủ toàn bộ danh sách (kể cả item không thay đổi).
   */
  update(id, data) {
    return http.put(`receipt/v1/tuition/managing-total-revenues/${id}`, data);
  }

  /**
   * Xóa mềm khoản thu chính
   * @param {string} id - UUID
   */
  remove(id) {
    return http.delete(`receipt/v1/tuition/managing-total-revenues/${id}`);
  }
}

export default new ManagingTotalRevenueService();

